<template>
  <CrudForm
      :title="title"
      :labelSubmit="labelSubmit"
      :storeName="storeName"
      :parentStoreName="parentStoreName"
      :parentUrlKey="parentUrlKey"
      :submit="submit"
    :status="status">
    <ValidationObserver ref="validator" v-slot="{}">
      <v-row justify="center">
        <v-col cols="6">
          <v-row>
            <v-col>
              <ValidationProvider ref="total" rules="required" v-slot="{ errors }">
                <v-text-field :error-messages="errors" v-model="data.total" label="Total"
                  prepend-inner-icon="fas fa-file" type="number"></v-text-field>
              </ValidationProvider>
            </v-col>
            <v-col>
              <ValidationProvider ref="total" rules="required" v-slot="{ errors }">
                <v-text-field :error-messages="errors" v-model="data.sub_total" label="Sub total"
                  prepend-inner-icon="fas fa-file" type="number"></v-text-field>
              </ValidationProvider>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <ValidationProvider ref="discount" rules="" v-slot="{ errors }">
                <v-text-field :error-messages="errors" v-model="data.discount" label="Discount" min="0"
                  prepend-inner-icon="fas fa-file" type="number"></v-text-field>
              </ValidationProvider>
            </v-col>
            <v-col>
              <ValidationProvider ref="fee" rules="" v-slot="{ errors }">
                <v-text-field :error-messages="errors" v-model="data.fee" label="Fee"
                  prepend-inner-icon="fas fa-file" type="number"></v-text-field>
              </ValidationProvider>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <ValidationProvider
                  ref="stores"
                  rules="required"
                  v-slot="{ errors }"
              >
                <v-select
                    :error-messages="errors"
                    v-model="data.store_id"
                    label="Store"
                    :items="stores"
                    item-value="id"
                    item-text="name"
                >
                  <template slot="no-data">
                    <v-alert :value="true"> There is no info to show </v-alert>
                  </template>
                </v-select>
              </ValidationProvider>
            </v-col>
            <v-col>
              <ValidationProvider
                  ref="status"
                  rules="required"
                  v-slot="{ errors }"
              >
                <v-select
                    :error-messages="errors"
                    v-model="data.status"
                    label="Status"
                    :items="statuses"
                >
                  <template slot="no-data">
                    <v-alert :value="true"> There is no info to show </v-alert>
                  </template>
                </v-select>
              </ValidationProvider>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <ValidationProvider ref="" rules="" v-slot="{ errors }">
                <v-textarea :error-messages="errors" v-model="data.note" label="Note"
                            prepend-inner-icon="fas fa-file" readonly="true"></v-textarea>
              </ValidationProvider>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <ValidationProvider
                  ref="status"
                  rules=""
                  v-slot="{ errors }"
              >
                <v-select
                    :error-messages="errors"
                    v-model="data.note_status"
                    label="Note Status"
                    :items="note_status"
                    item-value="value"
                    item-text="text"
                    readonly
                >
                  <template slot="no-data">
                    <v-alert :value="true"> There is no info to show </v-alert>
                  </template>
                </v-select>
              </ValidationProvider>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </ValidationObserver>
  </CrudForm>
</template>

<script>
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { mapState } from 'vuex';
import CrudForm from "@/components/Crud/CrudForm";
import Upload from "@/components/Upload";
import CrudFormMixin from '@/mixins/crud_form';

export default {
  mixins: [CrudFormMixin],
  components: { ValidationProvider, ValidationObserver, CrudForm },
  computed: {
    ...mapState({
      status: state => state.Orders.status,
      stores: (state) => state.Stores.list,
      notes() {
        return this.data.notes;
      }
    })
  },
  data() {
    return {
      storeName: 'Orders',
      parentStoreName:'Users',
      parentUrlKey:'user_id',
      title: "Orders",
      statuses: ['pending','delivered'],
      note_status: [
        {value: 1, text: 'All items scanned and paid for'},
        {value: 2, text: '1 items was not scanned or paid for'},
        {value: 3, text: '2 or more items were not scanned or paid for'},
      ],
      data: {
        user_id: "",
        store_id: "",
        status: "",
        total: "",
        sub_total: "",
        discount: "",
        fee: "",
        note: "",
        note_status: "",
        notes: []
      }
    }
  },
  async created() {
    const self = this;

    if(this.$route.params.user_id) this.data.user_id=this.$route.params.user_id;

    await self.$store.dispatch("Stores/getListAll", { show_all: "enable" });

  },
  watch: {
    notes() {
      if (this.data.notes.length > 0){
        this.data.note = this.data.notes[0].note;
        this.data.note_status = this.data.notes[0].status;
      }
    },
   
  },
  methods: {

  },
}
</script>
